import { data } from "../../mockData/banners-mock";
import CallApi from "../../util/CallApi";
export const FETCH_BANNERS = "FETCH_BANNERS";
export const FETCH_BANNERS_SUCCESS = "FETCH_BANNERS_SUCCESS";
export const FETCH_BANNERS_FAILURE = "FETCH_BANNERS_FAILURE";

const mockup = false;
const callApi = new CallApi();

export const fetchBanners = params => dispatch => {
  dispatch({ type: FETCH_BANNERS });
  if (mockup) {
    return dispatch({ type: FETCH_BANNERS_SUCCESS, payload: data });
  } else {
    return callApi
      .get("/project/banner/" + params.project_id)
      .then(res => {
        dispatch({ type: FETCH_BANNERS_SUCCESS, payload: res });
      })
      .catch(error => dispatch({ type: FETCH_BANNERS_FAILURE }));
  }
};
